module.exports = __webpack_public_path__ + "img/join_03.d0b84d92.png";